import { render, staticRenderFns } from "./OrderDown.vue?vue&type=template&id=36ab91bc&scoped=true"
import script from "./OrderDown.vue?vue&type=script&lang=js"
export * from "./OrderDown.vue?vue&type=script&lang=js"
import style0 from "./OrderDown.vue?vue&type=style&index=0&id=36ab91bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ab91bc",
  null
  
)

export default component.exports